import {selectSearchQueryParams} from '@computerrock/formation-router/sagas';
import contractPartnerScreenTabs from '../../contract-partners/contractPartnerScreenTabs';
import arcGISAuth from '../../arcGISAuth';

const loadArcGISAuthSession = function* loadArcGISAuthSession() {
    const {activeTab} = yield* selectSearchQueryParams();

    // exclude all tabs that doesn't use acrGIS
    if (activeTab !== contractPartnerScreenTabs.OPERATION_AREA) return;

    yield* arcGISAuth.loadAuthSession();
};

export default loadArcGISAuthSession;
